import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { v4 } from 'uuid';
import RoundItem from '~/components/DatesSlider/RoundItem';
import CustomArrow from '~/components/DatesSlider/CustomArrow';
import * as S from './styles';

export default function DatesSlider({
  options,
  getSlideRef,
  selectedDate,
  setCarouselDatesFilter,
  currentSlide,
  setCurrentSlide,
  slidesToShow,
  setDateFilter,
}) {
  const settings = {
    infinite: false,
    speed: 200,
    slidesToShow,
    lazyLoad: true,
    slidesToScroll: 1,
    variableWidth: true,
    prevArrow: (
      <CustomArrow orientation="left" isVisible={currentSlide !== 0} />
    ),
    nextArrow: <CustomArrow orientation="right" isVisible />,
    swipeToSlide: true,
    easing: 'ease-out',
  };

  const sliderRef = useRef();

  const selectDate = (date, firstMatchDay, index) => {
    setCurrentSlide(index);
    setCarouselDatesFilter(date);
    setDateFilter(firstMatchDay);
  };

  useEffect(() => {
    if (sliderRef.current) {
      getSlideRef(sliderRef.current);
    }
  }, [getSlideRef, sliderRef]);
  return (
    <S.SliderContainer>
      {options?.length ? (
        <Slider {...settings} initialSlide={+currentSlide} ref={sliderRef}>
          {options.map(
            ({ firstMatchDate, date, gameweeks, label, current }, index) => {
              const firstDate = firstMatchDate || date;
              return (
                <RoundItem
                  key={v4()}
                  dates={label}
                  selected={
                    (selectedDate === null && current) || date === selectedDate
                  }
                  rounds={gameweeks}
                  selectDate={() => {
                    selectDate(date, firstDate, index);
                  }}
                  showSeparator={index === options.length - 1}
                />
              );
            }
          )}
        </Slider>
      ) : null}
    </S.SliderContainer>
  );
}

DatesSlider.propTypes = {
  getSlideRef: PropTypes.func,
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  selectedDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setCarouselDatesFilter: PropTypes.func,
  currentSlide: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setCurrentSlide: PropTypes.func,
  slidesToShow: PropTypes.number,
  setDateFilter: PropTypes.func,
};

DatesSlider.defaultProps = {
  getSlideRef: () => {},
  options: [],
  isLoading: false,
  selectedDate: null,
  setCarouselDatesFilter: () => {},
  currentSlide: 0,
  setCurrentSlide: () => {},
  slidesToShow: 0,
  setDateFilter: () => {},
};
